export default __webpack_public_path__ + "static/media/Instagram.b642e35f.jpg";